import { Injectable, inject } from '@angular/core';
import { Observable, combineLatest, map, startWith } from 'rxjs';
import { ExtRouteService } from '@comparit/core';
import { TaskSyncBaseService } from '@comparit/shared';
import { Sparte, TaskService } from '@comparit/common-api';
import { UpdateKfzTaskRequest } from '../interfaces/generated';
import { skipReauth } from '../interceptors/kunde-reauth.interceptor';
import { toWireSortErgebnis } from '../helpers/sort-ergebnis-wire';
import { FormsService } from './forms.service';

/**
 * KFZ composition for the shared task-sync engine: the taskData mirrors the
 * "Stand speichern" payload (see StandSpeichernService.openWithCurrentState), so save
 * and background sync can never diverge.
 */
@Injectable({ providedIn: 'root' })
export class KfzTaskSyncService extends TaskSyncBaseService<UpdateKfzTaskRequest> {
  private readonly formsService = inject(FormsService);
  private readonly taskService = inject(TaskService);
  private readonly extRouteService = inject(ExtRouteService);

  protected override readonly updates$: Observable<UpdateKfzTaskRequest> = combineLatest([
    this.formsService.berechnungFormularValue$,
    this.formsService.calculatorForm.compare$,
    this.extRouteService.currentUrl$,
    this.formsService.acceptTermsAndConditions.valueChanges.pipe(
      startWith(this.formsService.acceptTermsAndConditions.value)
    ),
    this.formsService.calculatorForm.sortBy$,
    this.formsService.calculatorForm.sortDescending$,
  ]).pipe(
    map(([berechnungsvorgaben, selectedResults, route, agbAkzeptiert, sortBy, sortDescending]) => ({
      taskData: {
        sparte: Sparte.Kfz,
        berechnungsvorgaben,
        selectedResults,
        route,
        agbAkzeptiert,
        sortErgebnis: toWireSortErgebnis(sortBy),
        sortDescending,
      },
    }))
  );

  protected override sendUpdate(taskId: string, update: UpdateKfzTaskRequest) {
    return this.taskService.updateTask({ taskId, updateTaskRequest: update }, 'body', false, {
      context: skipReauth(),
    });
  }
}
